import { CbhFeatureFlag, useCbhFlag } from "../../../FeatureFlags";
import { ChartingCredentialStage } from "../../../FeatureFlags/CbhFeatureFlags";

interface UseCredentialSharingResult {
  isEnabled: boolean;
  isChartingOnly: boolean;
  isChartingAndTimeClock: boolean;
  isTimeClockOnly: boolean;
  stage: ChartingCredentialStage;
  enableOnboardingView: boolean;
  shiftStartingSoonThresholdInHours: number;
}

export function useCredentialSharing(): UseCredentialSharingResult {
  const { stage, enableOnboardingView, shiftStartingSoonThresholdInHours } = useCbhFlag(
    CbhFeatureFlag.CREDENTIAL_SHARING,
    {
      defaultValue: {
        stage: ChartingCredentialStage.OFF,
        enableOnboardingView: false,
        shiftStartingSoonThresholdInHours: 24,
      },
    }
  );

  return {
    isEnabled: stage !== ChartingCredentialStage.OFF,
    isChartingOnly: stage === ChartingCredentialStage.CHARTING_ONLY,
    isChartingAndTimeClock: stage === ChartingCredentialStage.CHARTING_AND_TIME_CLOCK,
    isTimeClockOnly: stage === ChartingCredentialStage.TIME_CLOCK_ONLY,
    stage,
    enableOnboardingView,
    shiftStartingSoonThresholdInHours,
  };
}
